import request from '@/utils/request'

export function selectBorderlessGraveSet(currentPage,pageSize,data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/borderlessGraveSet/selectBorderlessGraveSet?size=${pageSize}&current=${currentPage}`,
        method: 'post',
        data,
    })
}
export function addBorderlessGraveSet(data) {
    return request({
        url: `api/serviceCenter/borderlessGraveSet/addBorderlessGraveSet`,
        method: 'post',
        data,
    })
}

export function upDateBorderlessGraveSet(data) {
    return request({
        url: `api/serviceCenter/borderlessGraveSet/upDateBorderlessGraveSet`,
        method: 'post',
        data,
    })
}

export function bathDeleteBorderlessGraveSet(data) {
    return request({
        url: `api/serviceCenter/borderlessGraveSet/bathDeleteBorderlessGraveSet`,
        method: 'post',
        data,
    })
}







